var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 1.5,
    stroke: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3076 21L27.3076 18.1133L27.3076 23.8868L32.3076 21ZM9.69226 21L9.69226 21.5L27.8076 21.5L27.8076 21L27.8076 20.5L9.69226 20.5L9.69226 21Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextb);
export default __webpack_public_path__ + "static/media/nextb.8253082cd2760dd1a47570256f6a7deb.svg";
export { ForwardRef as ReactComponent };